module.exports = __webpack_public_path__ + "img/consultoria_4-3_1536.855f12e4.jpg";